export default __webpack_public_path__ + "static/media/pp-188-id.72904c55.png";